// import React from "react";
// import { 
//   X, User, Phone, Mail, MapPin, Calendar, 
//   Users, GraduationCap, Clock, ShieldCheck, Edit3
// } from "lucide-react";
// import { AnimatePresence, motion } from "framer-motion";

// const StudentDetailModal = ({ isOpen, student, onClose, onEdit }) => {
//   if (!student) return null;

//   // ✅ Đã xóa ": Icon" (lỗi TypeScript) để chạy được trên JS thuần
//   const infoItem = (Icon, label, value, color = "text-gray-500") => (
//     <div className="flex items-start gap-4 p-4 rounded-2xl hover:bg-gray-50 transition-colors">
//       <div className={`p-2.5 rounded-xl bg-white shadow-sm border border-gray-100 ${color}`}>
//         <Icon size={18} />
//       </div>
//       <div>
//         <p className="text-[11px] font-bold text-gray-400 uppercase tracking-widest mb-0.5">{label}</p>
//         <p className="text-sm font-semibold text-gray-800 leading-tight">{value || "Chưa cập nhật"}</p>
//       </div>
//     </div>
//   );

//   return (
//     <AnimatePresence>
//       {isOpen && (
//         <>
//           <motion.div
//             initial={{ opacity: 0 }} animate={{ opacity: 1 }} exit={{ opacity: 0 }}
//             className="fixed inset-0 bg-slate-900/60 backdrop-blur-sm z-[80]"
//             onClick={onClose}
//           />
//           <motion.div
//             initial={{ opacity: 0, x: "100%" }}
//             animate={{ opacity: 1, x: 0 }}
//             exit={{ opacity: 0, x: "100%" }}
//             transition={{ type: "spring", damping: 25, stiffness: 200 }}
//             className="fixed inset-y-0 right-0 w-full max-w-md bg-white z-[90] shadow-2xl flex flex-col"
//           >
//             {/* Header Profile */}
//             <div className="relative h-48 bg-gradient-to-br from-red-600 to-red-500 p-8 flex flex-col justify-end">
//               <button 
//                 onClick={onClose}
//                 className="absolute top-6 right-6 p-2 bg-black/10 hover:bg-black/20 text-white rounded-full transition-all"
//               >
//                 <X size={20} />
//               </button>
              
//               <div className="flex items-center gap-5">
//                 <div className="w-20 h-20 rounded-3xl bg-white shadow-xl flex items-center justify-center text-3xl font-black text-red-600 border-4 border-red-400/20">
//                   {student.full_name?.charAt(0).toUpperCase()}
//                 </div>
//                 <div className="text-white text-left">
//                   <h2 className="text-2xl font-black tracking-tight leading-tight">{student.full_name}</h2>
//                   <div className="flex items-center gap-2 mt-1">
//                     <span className="px-2 py-0.5 bg-white/20 rounded text-[10px] font-bold uppercase tracking-wider">
//                       ID: {student.id?.slice(0, 8)}
//                     </span>
//                     <span className={`px-2 py-0.5 rounded text-[10px] font-bold uppercase tracking-wider border ${
//                       student.status ? "bg-green-500/20 border-green-400 text-green-100" : "bg-gray-500/20 border-gray-400 text-gray-100"
//                     }`}>
//                       {student.status ? "Hoạt động" : "Tạm ngưng"}
//                     </span>
//                   </div>
//                 </div>
//               </div>
//             </div>

//             {/* Content Body */}
//             <div className="flex-1 overflow-y-auto custom-scrollbar p-6 space-y-8 text-left">
//               <section>
//                 <h3 className="text-xs font-black text-gray-400 uppercase tracking-[0.2em] mb-4 ml-4">Hồ sơ cá nhân</h3>
//                 <div className="grid grid-cols-1 gap-1">
//                   {infoItem(Calendar, "Ngày sinh", student.dob || "Chưa có", "text-blue-500")}
//                   {infoItem(Users, "Giới tính", student.gender === "male" ? "Nam" : "Nữ", "text-purple-500")}
//                   {infoItem(Phone, "Số điện thoại", student.phone, "text-red-500")}
//                   {infoItem(MapPin, "Địa chỉ cư trú", student.address, "text-orange-500")}
//                 </div>
//               </section>

//               <section className="bg-gray-50 rounded-3xl p-2 text-left">
//                 <h3 className="text-xs font-black text-gray-400 uppercase tracking-[0.2em] mt-4 mb-4 ml-4">Người bảo hộ</h3>
//                 <div className="grid grid-cols-1 gap-1">
//                   {infoItem(ShieldCheck, "Họ tên phụ huynh", student.parent_name, "text-green-600")}
//                   {infoItem(Phone, "SĐT phụ huynh", student.parent_phone, "text-green-600")}
//                 </div>
//               </section>

//               <section className="text-left">
//                 <h3 className="text-xs font-black text-gray-400 uppercase tracking-[0.2em] mb-4 ml-4">Học tập</h3>
//                 <div className="grid grid-cols-1 gap-1">
//                   {infoItem(GraduationCap, "Lớp học", student.class_name || "Chưa phân lớp", "text-indigo-600")}
//                   {infoItem(Clock, "Ngày nhập học", student.created_at?.slice(0,10) || "Chưa rõ", "text-gray-600")}
//                 </div>
//               </section>
//             </div>

//             <div className="p-6 border-t border-gray-100 flex gap-3 bg-white">
//               <button 
//                 onClick={() => onEdit(student)}
//                 className="flex-1 bg-red-600 hover:bg-red-700 text-white font-bold py-4 rounded-2xl flex items-center justify-center gap-2 shadow-lg shadow-red-200 transition-all active:scale-95"
//               >
//                 <Edit3 size={18} /> CHỈNH SỬA HỒ SƠ
//               </button>
//             </div>
//           </motion.div>
//         </>
//       )}
//     </AnimatePresence>
//   );
// };

// export default StudentDetailModal;





import React, { useEffect, useMemo, useState } from "react";
import {
  X,
  User,
  Phone,
  MapPin,
  Calendar,
  Users,
  GraduationCap,
  Clock,
  ShieldCheck,
  Edit3,
  Trash2,
  BookOpen,
  XCircle,
  Loader2,
  Hash,
} from "lucide-react";
import { AnimatePresence, motion } from "framer-motion";
import { fetchClassById } from "../../../api/elearning/classes/classes";
import { getAttendanceHistory } from "../../../api/elearning/attendance/attendance";
import { getStudentById } from "../../../api/elearning/students/students";
import { formatDateDDMMYYYY } from "../../../utils/formatUtils";

const StudentDetailModal = ({ isOpen, student, onClose, onEdit, onDelete }) => {
  const [detail, setDetail] = useState(null);

  useEffect(() => {
    if (!isOpen || !student?.id) {
      setDetail(null);
      return;
    }
    let cancelled = false;
    (async () => {
      try {
        const row = await getStudentById(student.id);
        if (!cancelled) setDetail(row);
      } catch {
        if (!cancelled) setDetail(null);
      }
    })();
    return () => {
      cancelled = true;
    };
  }, [isOpen, student?.id]);

  const view = detail || student;
  // Function hiển thị từng dòng thông tin
  const infoItem = (Icon, label, value, iconColor = "text-gray-400") => (
    <div className="flex items-center gap-3 p-2 rounded-lg hover:bg-gray-50 transition-colors border border-transparent hover:border-gray-100">
      <div className={`p-2 rounded-lg bg-gray-50 ${iconColor}`}>
        <Icon size={18} />
      </div>
      <div>
        <p className="text-[10px] font-bold text-gray-400 uppercase tracking-tight">{label}</p>
        <p className="text-[13px] font-semibold text-gray-700">{value || "Chưa cập nhật"}</p>
      </div>
    </div>
  );

  const latestClass = useMemo(() => {
    // view.classes[] được lấy theo thứ tự enrolled_at DESC (ở StudentListPage/backend)
    const classes = view?.classes;
    return Array.isArray(classes) && classes.length > 0
      ? classes[0]
      : null;
  }, [view]);

  const latestClassId = latestClass?.class_id || null;

  const [classDetail, setClassDetail] = useState(null);
  const [absentLogs, setAbsentLogs] = useState([]);
  const [attendanceLoading, setAttendanceLoading] = useState(false);
  /** null | 'forbidden' | 'error' — chỉ áp dụng block nhật ký điểm danh */
  const [attendanceNotice, setAttendanceNotice] = useState(null);
  const [showAllAbsent, setShowAllAbsent] = useState(false);

  const formatDate = (dateValue) => {
    if (!dateValue) return "";
    const d = new Date(dateValue);
    if (Number.isNaN(d.getTime())) return String(dateValue);
    const day = String(d.getDate()).padStart(2, "0");
    const month = d.toLocaleString("en-US", { month: "short" });
    const year = d.getFullYear();
    return `${day}-${month}-${year}`;
  };

  const formatDateTime = (dateValue) => {
    if (!dateValue) return "";
    const d = new Date(dateValue);
    if (Number.isNaN(d.getTime())) return String(dateValue);
    const day = String(d.getDate()).padStart(2, "0");
    const month = String(d.getMonth() + 1).padStart(2, "0");
    const year = d.getFullYear();
    const hour = String(d.getHours()).padStart(2, "0");
    const minute = String(d.getMinutes()).padStart(2, "0");
    return `${day}/${month}/${year} ${hour}:${minute}`;
  };

  useEffect(() => {
    if (!isOpen || !view) return;

    setClassDetail(null);
    setAbsentLogs([]);
    setAttendanceNotice(null);
    setShowAllAbsent(false);

    if (!latestClassId) return;

    let cancelled = false;
    (async () => {
      setAttendanceLoading(true);

      try {
        const cls = await fetchClassById(latestClassId, { silent: true });
        if (!cancelled) setClassDetail(cls || null);
      } catch {
        if (!cancelled) setClassDetail(null);
      }

      try {
        const history = await getAttendanceHistory(
          { class_id: latestClassId, page: 1, size: 50 },
          { silent: true }
        );
        if (cancelled) return;
        const records = history?.records || [];
        const sid = student?.id;
        setAbsentLogs(
          records.filter(
            (r) =>
              (r?.status === "Absent" ||
                r?.status === "AbsentExcused" ||
                r?.status === "AbsentUnexcused") &&
              (sid ? r?.student_id === sid : true)
          )
        );
        setAttendanceNotice(null);
      } catch (e) {
        if (cancelled) return;
        setAbsentLogs([]);
        const status = e?.response?.status;
        if (status === 403) {
          setAttendanceNotice("forbidden");
        } else {
          setAttendanceNotice("error");
        }
      } finally {
        if (!cancelled) setAttendanceLoading(false);
      }
    })();

    return () => {
      cancelled = true;
    };
  }, [isOpen, student?.id, latestClassId]);

  if (!student) return null;

  return (
    <AnimatePresence>
      {isOpen && (
        <>
          {/* Overlay nền tối nhẹ */}
          <motion.div
            initial={{ opacity: 0 }}
            animate={{ opacity: 1 }}
            exit={{ opacity: 0 }}
            className="fixed inset-0 bg-slate-900/40 backdrop-blur-sm z-[100] flex items-center justify-center p-4"
            onClick={onClose}
          >
            {/* Popup chính giữa */}
            <motion.div
              initial={{ opacity: 0, scale: 0.95, y: 20 }}
              animate={{ opacity: 1, scale: 1, y: 0 }}
              exit={{ opacity: 0, scale: 0.95, y: 20 }}
              onClick={(e) => e.stopPropagation()}
              className="bg-white w-full max-w-2xl rounded-3xl shadow-2xl overflow-hidden flex flex-col max-h-[90vh]"
            >
              {/* Header: Nền trắng, tối giản */}
              <div className="relative p-6 border-b border-gray-100 flex items-center justify-between">
                <div className="flex items-center gap-4">
                  <div className="w-16 h-16 rounded-2xl bg-red-50 text-red-600 flex items-center justify-center text-2xl font-black border border-red-100 shadow-sm">
                    {view.full_name?.charAt(0).toUpperCase()}
                  </div>
                  <div>
                    <h2 className="text-xl font-bold text-gray-800">{view.full_name}</h2>
                    <div className="flex items-center gap-2 mt-1">
                      <span className="px-2 py-0.5 bg-gray-100 text-gray-500 rounded text-[10px] font-bold uppercase">
                        ID: {view.id?.slice(0, 8)}
                      </span>
                      <span className={`px-2 py-0.5 rounded text-[10px] font-bold uppercase border ${
                        view.status 
                        ? "bg-green-50 border-green-100 text-green-600" 
                        : "bg-gray-50 border-gray-100 text-gray-400"
                      }`}>
                        {view.status ? "Đang học" : "Tạm ngưng"}
                      </span>
                    </div>
                  </div>
                </div>
                
                <button 
                  onClick={onClose}
                  className="p-2 hover:bg-gray-100 text-gray-400 hover:text-gray-600 rounded-full transition-all"
                >
                  <X size={24} />
                </button>
              </div>

              {/* Nội dung: Chia 2 cột */}
              <div className="flex-1 min-h-0 overflow-hidden p-6">
                <div className="h-full min-h-0 grid grid-cols-1 md:grid-cols-2 gap-6">
                  
                  {/* Cột trái: Thông tin cá nhân */}
                  <div className="min-h-0 overflow-y-auto pr-2 space-y-4">
                    <div>
                      <h3 className="text-[11px] font-black text-red-500 uppercase tracking-widest mb-3 flex items-center gap-2">
                        <div className="w-1 h-4 bg-red-500 rounded-full" /> Thông tin cá nhân
                      </h3>
                      <div className="space-y-1">
                        {infoItem(Hash, "Mã học sinh", view.student_code, "text-indigo-500")}
                        {infoItem(Calendar, "Ngày sinh", formatDateDDMMYYYY(view.dob), "text-blue-500")}
                        {infoItem(Users, "Giới tính", view.gender === "male" ? "Nam" : "Nữ", "text-purple-500")}
                        {infoItem(Phone, "Số điện thoại", view.phone, "text-red-600")}
                        {infoItem(MapPin, "Địa chỉ", view.address, "text-orange-500")}
                      </div>
                    </div>

                    <div>
                      <h3 className="text-[11px] font-black text-red-500 uppercase tracking-widest mb-3 flex items-center gap-2">
                        <div className="w-1 h-4 bg-red-500 rounded-full" /> Người bảo hộ
                      </h3>
                      <div className="space-y-1 bg-gray-50/50 p-2 rounded-2xl border border-gray-100">
                        {infoItem(ShieldCheck, "Họ tên phụ huynh", view.parent_name, "text-green-600")}
                        {infoItem(Phone, "SĐT liên hệ", view.parent_phone, "text-green-600")}
                      </div>
                    </div>
                  </div>

                  {/* Cột phải: Đào tạo & Nhật ký */}
                  <div className="min-h-0 overflow-y-auto pl-2 space-y-4">
                    <div>
                      <h3 className="text-[11px] font-black text-red-500 uppercase tracking-widest mb-3 flex items-center gap-2">
                        <div className="w-1 h-4 bg-red-500 rounded-full" /> Đào tạo
                      </h3>
                      <div className="space-y-1">
                        {infoItem(
                          GraduationCap,
                          "Lớp học hiện tại",
                          view.class_name || "Chưa phân lớp",
                          "text-indigo-600"
                        )}
                        {infoItem(
                          BookOpen,
                          "Khóa học",
                          latestClass?.course_name || "Chưa có khóa học",
                          "text-blue-500"
                        )}
                        {infoItem(
                          MapPin,
                          "Chi nhánh",
                          view.branch_name || "Chưa có chi nhánh",
                          "text-gray-500"
                        )}
                        {infoItem(
                          GraduationCap,
                          "Trường học",
                          view.school_name || classDetail?.school_name || "Chưa có trường học",
                          "text-gray-500"
                        )}
                        {infoItem(
                          Users,
                          "Giáo viên phụ trách",
                          classDetail?.teacher_name || "Chưa phân công",
                          "text-purple-500"
                        )}
                        {infoItem(
                          Clock,
                          "Ngày nhập học",
                          formatDateDDMMYYYY(view.created_at) || "Chưa rõ",
                          "text-gray-500"
                        )}
                        {infoItem(
                          User,
                          "Người tạo",
                          view.created_by_name || "Chưa có thông tin",
                          "text-cyan-600"
                        )}
                        {infoItem(
                          Calendar,
                          "Thời gian tạo",
                          formatDateTime(view.created_at) || "Chưa rõ",
                          "text-teal-600"
                        )}
                      </div>
                    </div>

                    <div>
                      <h3 className="text-[11px] font-black text-red-500 uppercase tracking-widest mb-3 flex items-center gap-2">
                        <div className="w-1 h-4 bg-red-500 rounded-full" /> Nhật ký điểm danh (Vắng)
                      </h3>

                      <div className="space-y-2">
                        {attendanceLoading ? (
                          <div className="flex items-center justify-center py-8">
                            <Loader2 className="animate-spin text-red-600" size={22} />
                          </div>
                        ) : attendanceNotice === "forbidden" ? (
                          <div className="bg-amber-50 border border-amber-200 rounded-2xl p-4">
                            <p className="text-[12px] font-semibold text-amber-900">
                              Không thể tải nhật ký điểm danh
                            </p>
                            <p className="text-[11px] text-amber-800 mt-1 leading-relaxed">
                              Tài khoản chưa được cấp quyền xem điểm danh. Phần còn lại của hồ sơ học viên vẫn hiển thị bình thường.
                            </p>
                          </div>
                        ) : attendanceNotice === "error" ? (
                          <div className="bg-gray-50 border border-gray-200 rounded-2xl p-4">
                            <p className="text-[12px] font-semibold text-gray-700">
                              Không tải được nhật ký điểm danh
                            </p>
                            <p className="text-[11px] text-gray-500 mt-1">
                              Vui lòng thử đóng và mở lại hồ sơ, hoặc liên hệ quản trị nếu lỗi lặp lại.
                            </p>
                          </div>
                        ) : absentLogs.length === 0 ? (
                          <div className="bg-red-50 border border-red-100 rounded-2xl p-4">
                            <p className="text-[12px] font-semibold text-red-700">
                              Chưa có bản ghi điểm danh vắng.
                            </p>
                          </div>
                        ) : (
                          absentLogs
                            .slice(0, showAllAbsent ? absentLogs.length : 6)
                            .map((item) => (
                            <div
                              key={item.attendance_id || `${item.student_id}-${item.date}`}
                              className="bg-red-50 border border-red-100 rounded-2xl p-3"
                            >
                              <div className="flex items-start justify-between gap-2">
                                <div className="flex items-center gap-2">
                                  <XCircle className="text-red-600" size={16} />
                                  <p className="text-[11px] font-black text-red-700 uppercase tracking-tight">
                                    Vắng
                                  </p>
                                </div>
                                <p className="text-[11px] font-bold text-gray-500">
                                  {formatDate(item.date)}
                                </p>
                              </div>

                              <div className="mt-1.5 space-y-1">
                                {item.teacher_note ? (
                                  <p className="text-[11px] font-semibold text-gray-800">
                                    {item.teacher_note}
                                  </p>
                                ) : (
                                  <p className="text-[11px] text-gray-500 italic">
                                    Không có ghi chú giáo viên
                                  </p>
                                )}

                                {item.staff_remark ? (
                                  <p className="text-[10px] text-blue-600 font-medium">
                                    Ghi chú CSKH: {item.staff_remark}
                                  </p>
                                ) : null}
                              </div>
                            </div>
                          ))
                        )}

                        {absentLogs.length > 6 && (
                          <button
                            type="button"
                            onClick={() => setShowAllAbsent((v) => !v)}
                            className="w-full text-left text-[12px] font-bold text-red-600 hover:text-red-700 transition-colors"
                          >
                            {showAllAbsent ? "Thu gọn" : "Xem thêm"}
                          </button>
                        )}
                      </div>
                    </div>
                  </div>

                </div>
              </div>

              {/* Footer hành động */}
              <div className="p-6 border-t border-gray-50 bg-gray-50/30 flex flex-wrap items-center justify-between gap-3">
                <button 
                  type="button"
                  onClick={onClose}
                  className="px-6 py-3 rounded-xl font-bold text-gray-500 hover:bg-gray-100 transition-all"
                >
                  ĐÓNG
                </button>
                <div className="flex flex-wrap gap-3 justify-end">
                  {onDelete && (
                    <button
                      type="button"
                      onClick={() => onDelete(student)}
                      className="px-6 py-3 rounded-xl font-bold text-red-600 border border-red-200 bg-white hover:bg-red-50 flex items-center gap-2 transition-all active:scale-[0.98]"
                    >
                      <Trash2 size={18} /> Xóa
                    </button>
                  )}
                  <button 
                    type="button"
                    onClick={() => onEdit?.(student)}
                    className="px-8 py-3 bg-red-600 hover:bg-red-700 text-white font-bold rounded-xl flex items-center gap-2 shadow-lg shadow-red-100 transition-all active:scale-95"
                  >
                    <Edit3 size={18} /> CHỈNH SỬA
                  </button>
                </div>
              </div>
            </motion.div>
          </motion.div>
        </>
      )}
    </AnimatePresence>
  );
};

export default StudentDetailModal;